'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _MobileApp = require('./MobileApp.scss');

var _MobileApp2 = _interopRequireDefault(_MobileApp);

var _reactRedux = require('react-redux');

var _session = require('redux/modules/session');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MobileApp: {
    displayName: 'MobileApp'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/MobileApp/MobileApp.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Link from 'components/Link/Link';

// @asyncConnect([{
//   promise: ({store: {dispatch}}) => {
//     return dispatch(loadDtac());
//   }
// }])

var MobileApp = _wrapComponent('MobileApp')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user
  };
}, { setMobilePopup: _session.setMobilePopup, openMobileApp: _session.openMobileApp }), _dec2 = (0, _reactCssModules2.default)(_MobileApp2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MobileApp, _Component);

  function MobileApp() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MobileApp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MobileApp.__proto__ || (0, _getPrototypeOf2.default)(MobileApp)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function () {
      _this.props.openMobileApp(false);
    }, _this.disablePopup = function () {
      _this.props.openMobileApp(false);
      _this.props.setMobilePopup(false);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MobileApp, [{
    key: 'render',
    value: function render() {
      var mobileImage = require('./mobile-app.png');
      var appStoreImage = require('./app-store.png');
      var playStoreImage = require('./play-store.png');
      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'div',
          { styleName: 'header' },
          _react3.default.createElement(
            'h3',
            null,
            'TakeMeTour app is now available'
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'content-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'image-container' },
            _react3.default.createElement('img', { src: mobileImage, alt: 'mobile app' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'content' },
            _react3.default.createElement(
              'p',
              null,
              'Chat with Local Expert faster & easier than ever with TakeMeTour App (iOS & Androids). Download now and enjoy chatting!'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'button-container' },
            _react3.default.createElement(
              'a',
              { styleName: 'ios-link', onClick: this.disablePopup, href: 'https://itunes.apple.com/us/app/takemetour/id1119993464?mt=8', target: '_blank' },
              _react3.default.createElement('img', { src: appStoreImage, alt: 'app store' })
            ),
            _react3.default.createElement(
              'a',
              { styleName: 'android-link', onClick: this.disablePopup, href: 'https://play.google.com/store/apps/details?id=com.mobilelx&hl=en', target: '_blank' },
              _react3.default.createElement('img', { src: playStoreImage, alt: 'play store' })
            )
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'p',
              null,
              _react3.default.createElement(
                'a',
                { styleName: 'text-link', onClick: this.onClose },
                'Download later'
              )
            ),
            _react3.default.createElement(
              'p',
              null,
              _react3.default.createElement(
                'a',
                { styleName: 'text-link', onClick: this.disablePopup },
                'Never show this again'
              )
            )
          )
        )
      );
    }
  }]);
  return MobileApp;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  openMobileApp: _react2.PropTypes.func,
  setMobilePopup: _react2.PropTypes.func
}, _temp2)) || _class) || _class));

exports.default = MobileApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileApp/MobileApp.js
// module id = 1566
// module chunks = 47